import { OrganizationApi, ToastStateHandler } from '../../../api';
import { PatchOrganizationDto } from '../../../commonTypes/organization.types';
import { dispatch } from '../../../store';
import { editOrganization } from '../../../store/slices/organization.slice';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpToPatchOrganization = () => {
    const { t } = useTranslation('newNotifications');
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (organizationId: string, body: PatchOrganizationDto) => {
        const parsedBody = {
            ...body,
            currencyId: body.currency?.id,
        };
        delete parsedBody.currency;

        const { exec, abort } = organizationApi.patchOrganization({
            params: { organizationId },
            body: parsedBody,
            onSuccess: _ => {
                dispatch(editOrganization(body));
                toastHandler.push('success', t('organization.updateOrganizationTitle'), t('organization.updateOrganizationMessage_Success'));
            },
            onError: (error: any) => {
                if (error) toastHandler.push('error', t('organization.updateOrganizationTitle'), t('organization.updateOrganizationMessage_Failed'));
                else return error;
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpToPatchOrganization;
